import CircularProgress from '@rentspree/component-2023.components.organisms.circular-progress'
import styled from 'styled-components'

const CenterContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  padding: 30px 15px;
  height: calc(100vh);
  &.-w100 {
    width: 100%;
  }
  &.-mH100 {
    min-height: 100%;
  }
  @media (max-width: 991px) {
    height: calc(100vh);
  }
`
export const Loading = (): JSX.Element => (
  <CenterContent>
    <CircularProgress />
  </CenterContent>
)
